import { apiCall } from './generated/gqlClient';

const getAllWebIntegrationsApiRequest = async () => {
  const query = `
    query {
      getAllWebIntegrations {
        background
        base
        body
        button
        font
        fontname
        gradient
        id
        link
        name
        page
        providerId
        integrationType
        url
        integrationCode
        configuration {
          showVideos
          showServices
          showEvents
          showCourses
          showMemberships
          primaryColor
        }
      }
    }
  `;
  return apiCall({ query });
};

const saveWebIntegrationApiRequest = async ({ id, name, url, showVideos, showServices, showEvents, showCourses, showMemberships, primaryColor }) => {
  const mutation = `
    mutation saveWebIntegration(
      $name: String!
      $url: String!
      $showVideos: Boolean!
      $showServices: Boolean!
      $showEvents: Boolean!
      $showCourses: Boolean!
      $showMemberships: Boolean!
      $primaryColor: String!
      $id: Int
    ) {
      saveWebIntegration(
        name: $name
        url: $url
        showVideos: $showVideos
        showServices: $showServices
        showEvents: $showEvents
        showCourses: $showCourses
        showMemberships: $showMemberships
        primaryColor: $primaryColor
        id: $id
      ) {
        id
        success
        message
      }
    }
  `;
  return apiCall({
    query: mutation,
    variables: {
      id: +id,
      name,
      url,
      showVideos: showVideos === 'true',
      showServices: showServices === 'true',
      showEvents: showEvents === 'true',
      showCourses: showCourses === 'true',
      showMemberships: showMemberships === 'true',
      primaryColor,
    },
  });
};

const deleteWebIntegrationApiRequest = async id => {
  const mutation = `
    mutation deleteWebIntegration($id: Int) {
      deleteWebIntegration(id: $id) {
        success
        message
      }
    }
  `;
  return apiCall({ query: mutation, variables: { id: +id } });
};

const getWebIntegrationApiRequest = async id => {
  const query = `
    query getWebIntegration($id: Int!) {
      getWebIntegration(id: $id) {
        background
        base
        body
        button
        font
        fontname
        gradient
        id
        link
        name
        page
        providerId
        integrationType
        url
        integrationCode
        configuration {
          showVideos
          showServices
          showEvents
          showCourses
          showMemberships
          primaryColor
          askEmail
          askFirstname
          askLastname
          askPhone
          fontFamily
          fontStyle
          widgetMode
          authLoginBackground
          authLoginText
          authLoginBorder
          authLoginBorderWidth
          authRegisterBackground
          authRegisterText
          authRegisterBorder
          authRegisterBorderWidth
          authButtonBorderRadius
          authVisibleButtons
        }
        provider {
          id
          name
          acceptPayments
          onlineDiscount
          images {
            medium
            large
            xLarge
          }
          memberships {
            id
            providerId
            name
            color
            counter
            type
            offers {
              id
              providerId
              name
              description
              price
              sessionsCounter
              duration
              durationType
              isRecurringPayment
              isPublished
              startTime
              endTime
              userHasMembership
            }
          }
          services {
            id
            name
            type
          }
          courses {
            id
            name
            type
          }
          events {
            id
            name
            type
          }
          resources {
            id
            name
            schedules {
              workTime {
                startTime
                endTime
              }
              day
            }
          }
          plan {
            id
            endsAt
          }
        }
      }
    }
  `;
  return apiCall({ query, variables: { id } });
};

export { deleteWebIntegrationApiRequest, getAllWebIntegrationsApiRequest, getWebIntegrationApiRequest, saveWebIntegrationApiRequest };
